import React from 'react';
import './Myorder.css';
import { Link } from 'react-router-dom';
import TotalProduct from './TotalProduct';
const Myorder = ({ orders, windowDimensions }) => {
    return (
        <div className='container my-order'>
            <div className="row">
                {/* <div className="col-12 col-md-8 col-sm-7 col-lg-9">
                    <h6>Items Details ({orders?.orderInfo?.length} item)</h6>
                </div> */}
                {
                    windowDimensions?.width > 575 && <>
                        <div className="col-md-2 text-center col-sm-2 col-lg-2">
                            <h6>Order ID</h6>
                        </div>
                        <div className="col-md-2 text-center col-sm-2 col-lg-2">
                            <h6>Product</h6>
                        </div>
                        <div className="col-md-2 text-center col-sm-2 col-lg-2">
                            <h6>Status</h6>
                        </div>
                        <div className="col-md-2 text-center col-sm-2 col-lg-2">
                            <h6>Track Product</h6>
                        </div>
                        <div className="col-md-2 text-center col-sm-2 col-lg-2">
                            <h6>Total Product</h6>
                        </div>
                        <div className="col-md-2 text-center col-sm-2 col-lg-2" >
                            <h6>Amount</h6>
                        </div>

                    </>
                }

            </div>
            <hr />
            {
                orders ? orders?.orderInfo?.map((item, index) => (
                    <div key={index}>
                        <div className="row" >
                            <div className="col-12 text-center col-md-2 col-sm-2 col-lg-2 qty-block">
                                <h5 className='pd-qty '>
                                    {windowDimensions?.width < 576 ? `ID: ${item.orderId}` : `${item.orderId}`}
                                </h5>
                            </div>

                            <div className="col-12 text-center col-md-2 col-sm-2 col-lg-2 qty-block">
                                <TotalProduct requestProduct={item.requestProduct} />
                            </div>
                            <div className={`col-12 text-center col-md-2 col-sm-2 col-lg-2 qty-block status-${item.status}-block`}>
                                <h5 className={`pd-qty status-${item.status}`}>
                                    {windowDimensions?.width < 576 ? `${item.status}` : `${item.status}`}
                                </h5>
                            </div>
                            <div className={`col-12 text-center col-md-2 col-sm-2 col-lg-2 qty-block`}>
                                <h5 className={`pd-qty`}>
                                    <Link to={`/track-order/${orders._id}/${item.orderId}`}>
                                        Track My Order
                                    </Link>
                                </h5>
                            </div>
                            <div className="col-12 text-center col-md-2 col-sm-2 col-lg-2 qty-block">
                                <h5 className='pd-qty '>
                                    {windowDimensions?.width < 576 ? `Total Product: ${item.requestProduct?.length}` : `${item.requestProduct?.length}`}
                                </h5>
                            </div>
                            {
                                windowDimensions?.width > 575 && <div className="col-12 col-md-2 text-center col-sm-2 col-lg-2">
                                    <h5 className='pd-total'>৳{item.requestProduct?.reduce(
                                        (total, prd) => total + (parseInt(prd.price) * prd.orderQuantity), 0)}</h5>
                                </div>
                            }
                        </div>
                        <br />
                        <hr />
                    </div>
                ))
                :
                <p className='text-center'>Still your doesn't have any order.</p>

            }
        </div>
    );
};

export default Myorder;